import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import {
  getConfirmAssets,
  addTagsConfirmAsset,
  changeNameConfirmAsset,
  changeCopyRightConfirmAsset,
  confirmAsset,
  deleteAsset,
  moveFolderConfirmAsset,
  confirmBy
} from '../../actions/AssetsConfirmAction'
import { Row, Col, Divider, Button, Icon, Input, Spin, Select, Empty, Form } from 'antd'
import Magnifier from "react-magnifier"
import Pagination from '../pagination/Pagination'
import DocumentView from '../document-view/DocumentView'
import VideoView from '../assets-view/VideoView'
import Copyright from '../upload/Copyright'
import fileextension from 'file-extension'
import { sendNotification, getPermission } from '../../utils/index'
import TagV2 from '../tagV2/TagV2'
import { Link } from 'react-router-dom'
import Breadcrumb from '../breadcrumb/Breadcrumb'
import '../../components/private-site/privateSite.css'

const { Option } = Select

const spinnerStyle = {
  textAlign: 'center',
  background: 'rgba(0, 0, 0, 0.05)',
  borderRadius: 4,
  marginBottom: 20,
  padding: '30px 50px',
  margin: '20px 0'
}

export class ConfirmAssets extends Component {
  constructor(props) {
    super(props)
    this.containerRef = React.createRef()
    this.state = {
      activePage: 1,
      startDelete: '',
      start: '',
      folderDestinationEdit: null,
      folderId: '',
      close: false,
      editRoute: null,
      canOrder: false,
      canDelete: false,
      dataConfirm: []
    }
  }

  componentDidMount() {
    const { matrix, user } = this.props

    this.handleGetData()
    this.handleRoute()
    this.setState({
      canDelete: user.clientRole === 'admin' || getPermission(matrix, 'delete'),
    })
    setTimeout(() => {
      this.handleScrollTo()
    }, 700)
  }

  componentDidUpdate(prevProps) {
    const { data, error } = this.props

    if (prevProps.data && data) {
      if (prevProps.data.length < data.length && prevProps.data.length === 0) {
        setTimeout(() => {
          this.handleScrollTo()
        }, 100)
      }
    }
    if (prevProps.error !== error) {
      this.setState({
        startDelete: '',
        start: '',
      })
    }
  }

  handleGetData = () => {
    const { activePage } = this.state
    const { workclient, idUser } = this.props
    this.props.getConfirmAssets(workclient, activePage, idUser)
  }

  handleChangePage = (page = 1) => {
    this.setState({
      activePage: page
    }, () => {
      this.handleGetData()
    })
  }

  handleScrollTo = () => {
    if (this.containerRef && this.containerRef.current) {
      window.scroll({ top: this.containerRef, left: 0, behavior: 'smooth' })
    }
  }

  handleCopyright = (copyright, item) => {
    this.props.changeCopyRightConfirmAsset(copyright, item)
  }

  handleOnInputChange = (e, item) => {
    this.props.changeNameConfirmAsset(e.target.value, item)
  }

  handleEditAsset = (item) => {
    const { workclient, page, intl, idUser } = this.props
    const { activePage, folderId } = this.state

    this.setState(({
      start: item._id
    }), () => {
      this.props.confirmAsset(workclient, item, activePage, intl, idUser)
    })

    if (folderId) {
      this.props.moveFolderConfirmAsset(workclient, item, folderId, page, intl)
    }
    this.setState({
      folderId: ''
    })
  }

  handleCreateAsset = () => {
    this.setState({
      start: true
    })
  }

  handleDeleteAsset = (item) => {
    const { workclient, intl, idUser } = this.props
    const { activePage } = this.state

    this.setState({
      startDelete: item._id
    })
    this.props.deleteAsset(workclient, item, activePage, intl, idUser)
  }

  handleDeleteTag = (index, item) => {
    item.metadata.descriptiveTags.splice(index, 1)
    this.props.addTagsConfirmAsset(item, item.metadata.descriptiveTags)
  }

  handleCopyClipboard = (tags) => {
    const { intl } = this.props
    if (tags && tags.length > 0) {
      const tagsToText = tags.join(',')
      let textField = document.createElement('textarea')
      textField.innerText = tagsToText
      document.body.appendChild(textField)
      textField.select()
      document.execCommand('copy')
      textField.remove()
      sendNotification('success', intl, intl.formatMessage({ id: "tags_clipboard" }))
    }
    else {
      sendNotification('info', intl, intl.formatMessage({ id: "no_tags_copy" }))
    }
  }

  handleTags = (objectTag, item) => {
    this.props.addTagsConfirmAsset(item, objectTag.tags)
  }

  handleRoute = r => {
    const { breadcrumb } = this.props
    let route = []

    if (r && r.parents) {
      r.parents.forEach(itemParents => {
        breadcrumb.forEach(breadElement => {
          if (itemParents === breadElement._id)
            route.push({ id: breadElement._id, name: breadElement.name })
        })
      })
      return route
    }
  }

  handleEditRoute = (item) => {
    const { close } = this.state
    this.setState({
      close: !close,
      editRoute: item._id,
      folderId: ''
    })
  }

  handleFolderSelect = (folderId, r) => {
    const { intl } = this.props

    const currentFolder = this.handleRoute(r).slice(-1)
    if (folderId === currentFolder[0].id) {
      sendNotification('error', intl, intl.formatMessage({ id: "must_select_different" }))
      this.setState({
        editRoute: null,
        folderId: ''
      })
    } else {
      this.setState({
        folderId,
      })
    }
  }

  handleConfirmChange = (value) => {
    const { activePage } = this.state
    const { workclient, idUser } = this.props

    this.props.confirmBy(value)
    this.props.getConfirmAssets(workclient, activePage, idUser)
  }

  render() {
    const { headers, newColor, isFetching, intl, data, confirmAssetsBy } = this.props
    const { activePage, start, startDelete, folderId, close, editRoute, canDelete } = this.state

    return (
      <React.Fragment>
        <div className="title-bar">
          <div className="container filter" style={{ borderLeftColor: newColor }}>
            <span>{intl.formatMessage({ id: "confirm" })}</span>
            <span style={{ fontSize: '12px', float: 'right', marginTop: '-15px', marginRight: '36px' }}>{intl.formatMessage({ id: "confirm_by" })}:</span>
            <ul>
              <Select className='arrowSelect' defaultValue={confirmAssetsBy} onChange={this.handleConfirmChange} style={{ size: 'small', width: 112, color: newColor, marginRight: '-104px', marginTop: '5px' }}>
                <Option value="mine">{intl.formatMessage({ id: "my_user" })}</Option>
                <Option value="all">{intl.formatMessage({ id: "all" })}</Option>
              </Select>
            </ul>
          </div>
        </div>
        <div className="assets-wrapper">
          {!isFetching
            ? <div className="container" ref={this.containerRef}>
              {data.length === 0 && <Empty description={intl.formatMessage({ id: "no_asset_confirm" })} style={{ marginLeft: '30px' }} />}
              {data.map((r, k) =>
                <div key={k}>
                  {console.log('r', r)}
                  <Row>
                    <Col span={6}>
                      {r.type === 'image' && <Magnifier style={{
                        maxWidth: '90%',
                        width: '90%',
                        height: 'auto',
                        margin: 'auto'
                      }}
                        alt={r.name}
                        src={r.lowQualityURL} />}
                      {r.type === 'video' &&
                        <VideoView
                          url={r.mediaQualityURL}
                          disableDefaultControls={false}
                          autoPlay={false}
                        />}
                      {r.type === 'document' && <DocumentView
                        item={r}
                        from={`middleView`} />}
                      <Row>
                        <Col style={{ paddingBottom: 10 }}>
                          <span key={k + 'ruta'}>{intl.formatMessage({ id: "path" })}: </span>
                          {this.handleRoute(r).map((r, k) => <Link
                            to={`/home/explore/${r.id}`}
                            key={k}
                            style={{ fontSize: 13, cursor: 'pointer' }}>
                            {r.name}/
                          </Link>)}
                          <Icon
                            type="edit"
                            onClick={() => this.handleEditRoute(r)}
                          />
                        </Col>
                      </Row>
                      {close && editRoute === r._id &&
                        <Row>
                          <Col >
                            <Form style={{ width: '90%' }}>
                              <Form.Item>
                                <Breadcrumb
                                  placeholder={intl.formatMessage({ id: "destination_folder" })}
                                  value={folderId}
                                  handleFolderSelect={(folderId) => this.handleFolderSelect(folderId, r)}
                                  changeFolder={false}
                                />
                              </Form.Item>
                            </Form>
                          </Col>
                        </Row>}
                    </Col>
                    <Col span={18} style={{ padding: '0 10px' }}>
                      <Row>
                        <Col style={{ paddingBottom: 10 }}>
                          <span key={k + 'name'}>{intl.formatMessage({ id: "name" })}: </span><Input
                            defaultValue={r.name}
                            onBlur={(e) => this.handleOnInputChange(e, r)}
                            allowClear={true}
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col style={{ paddingBottom: 10 }}>
                          <span key={k + 'extension'}>{intl.formatMessage({ id: "extension" })} .{fileextension(r.originalURL)}</span>
                        </Col>
                      </Row>
                      <Row>
                        <Col style={{ paddingBottom: 10 }}>
                          <span key={k + 'name'}>{intl.formatMessage({ id: "uploaded_by" })}: {r.username} </span>
                        </Col>
                      </Row>
                      <Row>
                        <Col style={{ paddingBottom: 10 }}>
                          <span key={k + 'tags'}>Tags</span>
                          <TagV2 fillTags={r.metadata.descriptiveTags} handleTags={tag => this.handleTags(tag, r)} />
                        </Col>
                      </Row>
                      <Row>
                        <Col style={{ paddingBottom: 10 }}>
                          <Copyright
                            fillRightsStatus={r.metadata.rightsStatus}
                            fillCreateDate={r.metadata.createdDate}
                            fillDueDate={r.metadata.dueDate}
                            handleCopyright={(copyright) => this.handleCopyright(copyright, r)} />
                        </Col>
                      </Row>
                      <Row>
                        <Col style={{ paddingBottom: 10 }}>
                          <Button
                            loading={start === r._id
                              ? true
                              : false}
                            type="primary"
                            style={{ backgroundColor: newColor, borderColor: newColor }}
                            onClick={() => this.handleEditAsset(r)}
                          >{intl.formatMessage({ id: "confirm" })}<Icon type="check" />
                          </Button>
                          {canDelete && <Button
                            loading={startDelete === r._id
                              ? true
                              : false}
                            type="default"
                            style={{ color: newColor, borderColor: newColor, marginLeft: '10px' }}
                            onClick={() => this.handleDeleteAsset(r)}
                          >{intl.formatMessage({ id: "delete_asset" })}</Button>}
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Divider />
                    </Col>
                  </Row>
                </div>
              )}
              <Pagination
                keyCollection='assetsConfirm'
                handleChangePage={this.handleChangePage}
                activePage={activePage}
                headers={headers}
                defaultPageSize={10}
              />
            </div>
            : <div style={spinnerStyle}><Spin spinning={isFetching} /></div>
          }
        </div>
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    data: state.assetsConfirm.data,
    workclient: state.client.workclient,
    headers: state.assetsConfirm.headers,
    newColor: state.authUser.user && state.authUser.user.color ? state.authUser.user.color : '#2E97CF',
    isFetching: state.assetsConfirm.isFetching,
    breadcrumb: state.client.breadcrumb,
    itemSelected: state.assetsExplore.data.find(r => r.isMoveSelected),
    folderselect: state.assetsExplore.folderselect,
    page: state.assetsExplore.page,
    idUser: state.authUser.user._id,
    user: state.authUser.user,
    matrix: state.group.matrix,
    confirmAssetsBy: state.assetsConfirm.confirmAssetsBy
  }
}

const mapDispatchToProps = {
  getConfirmAssets,
  addTagsConfirmAsset,
  changeNameConfirmAsset,
  changeCopyRightConfirmAsset,
  confirmAsset,
  deleteAsset,
  moveFolderConfirmAsset,
  confirmBy
}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(ConfirmAssets)))